import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import DayPicker from '@peerspace/react-day-picker';
import { Tooltip } from '../../../../../elements-tooltip/tooltip-v2';
import { injectIntl, FormattedMessage, intlShape } from 'react-intl';

class DateField extends React.Component {
  constructor (props) {
    super(props);
    this.captureDate = this.captureDate.bind(this);
  }

  captureDate (date, { disabled }) {
    if (disabled) return;
    const { input = {} } = this.props;
    const { onChange } = input;

    if (date) onChange(moment(date).toDate());
    this.tooltipComponent.externallyCloseTooltip();
  }

  anchorClickCB ({ open, showTooltip }) {
    showTooltip(!open);
  }

  render () {
    const {
      input = {},
      inputClassName = '',
      calendarPlacement = '',
      additionalInfo = '',
      placeholder = null,
      arrowPlacement = '',
      attributes = {},
      meta = {},
      datePickerProps = {},
      dateFormat = 'll',
      intl
    } = this.props;

    const capturedDate = input.value;
    const { error, submitFailed } = meta;
    const { value, ...restOfInput } = input;

    return (
      <div className="availability-container">
        <Tooltip
          ref={ (ref) => { this.tooltipComponent = ref; }}
          placement={calendarPlacement || 'bottom'}
          tooltipClass="availability-popover"
          anchorClickCB={this.anchorClickCB}
          anchorType="custom"
          openCB={this.onDayPickerOpen}
          exitCB={this.onDayPickerExit}
          showX
          arrowPlacement={arrowPlacement}
          customAnchor={
            <div className="datepicker__input-container">
              <input
                {...restOfInput}
                value={value}
                type="hidden"
              />
              <input
                value={value ? moment(value).format(dateFormat) : ''}
                type="text"
                placeholder={placeholder || intl.formatMessage({ id: 'hosting.date_field.placeholder_date', defaultMessage: 'start date' })}
                className={classNames('form-control datepicker__input', inputClassName)}
                readOnly
                {...attributes}
              />
            </div>
          }
          hideOnClickAnywhere
          shouldUpdatePosition
        >
          <div className="container-fluid text-center">
            <div className="row">
              <div className="col-xs-12">
                <DayPicker
                  {...datePickerProps}
                  onDayClick={this.captureDate}
                  className="availability-calendar"
                  month={capturedDate}
                  selectedDays={capturedDate}
                />
              </div>
            </div>
            {
              additionalInfo ?
                <div className="row">
                  <div className="col-xs-12">
                    <div className="additional-info text-center margin-lg-bottom">{additionalInfo}</div>
                  </div>
                </div>
                : null
            }
          </div>
        </Tooltip>
        {
          error && submitFailed && <p className="help-block inline-help text-danger text-left">
            <FormattedMessage
              id="hosting.date_field.error_message_date"
              defaultMessage="Please enter a date"
            />
          </p>
        }
      </div>
    );
  }
}

DateField.propTypes = {
  calendarPlacement: PropTypes.string,
  additionalInfo: PropTypes.string,
  placeholder: PropTypes.string,
  arrowPlacement: PropTypes.object,
  input: PropTypes.object,
  inputClassName: PropTypes.string,
  attributes: PropTypes.object,
  meta: PropTypes.object,
  datePickerProps: PropTypes.object,
  dateFormat: PropTypes.string,
  intl: intlShape
};

export default injectIntl(DateField);
